let id = 0;

export default function incrementingId() {
    return ++id;
}
